import * as React from 'react';

import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';

import { venueListVenueBlockedUsers } from '../../api/users/venueListVenueBlockedUsers';
import {
  BlockedUser,
  VenueListAccessRequetsFilter,
  VenueListVenueBlockedUsersRequest,
} from '../../graphql/API';
import { useAppSelector } from '../../redux/hooks';
import { QueryResult } from './types';

const PAGE_LIMIT = 50;

const useListBlockedUserQuery = (
  filters: Partial<VenueListVenueBlockedUsersRequest> | undefined,
  disable?: boolean,
): QueryResult<BlockedUser[]> => {
  const venueState = useAppSelector((state) => state.venue.value);

  const { data, fetchNextPage, hasNextPage, isFetching, isLoading, refetch } = useInfiniteQuery<
    BlockedUser[]
  >({
    initialPageParam: 0,
    queryKey: ['list-blocked-users', venueState?.id, filters],
    queryFn: async ({ queryKey, pageParam }) => {
      const [, venueID, queryFilters] = queryKey as [string, number, VenueListAccessRequetsFilter];
      const offset = <number>pageParam * PAGE_LIMIT;

      return venueListVenueBlockedUsers({ ...queryFilters, limit: PAGE_LIMIT, offset, venueID });
    },
    getNextPageParam: (lastGroup, groups) =>
      lastGroup.length === PAGE_LIMIT ? groups.length : undefined,
    placeholderData: keepPreviousData,
    enabled: !disable && !!venueState?.id,
    refetchOnWindowFocus: false,
  });

  const flatData = React.useMemo(() => data?.pages.flatMap((x) => x) ?? [], [data]);


  return { data: flatData, isFetching, isLoading, fetchNextPage, hasNextPage, refetch };
};

export default useListBlockedUserQuery;
